import { convertMSToMMSS } from '@wix/wix-vod-shared/dist/src/common/utils/time';

export function useDuration(milliseconds?: number): string | undefined {
  if (milliseconds) {
    return convertMSToMMSS(milliseconds);
  }
}
